import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';

import { CheveronDownIcon } from '@wkda/icons';

import { CheckBox } from './CheckBox';

import * as styles from './Item.module.scss';
import { PTContentSection } from '../pTypes';

/**
 * @typedef {Object} ContentSection
 * @property {string} title
 * @property {string} description
 */

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {boolean} props.isSelected
 * @param {() => void} [props.onSelect]
 * @param {() => void} props.onClick
 * @param {ContentSection} props.content
 * @param {string} [props.name]
 * @param {string} props.value
 */
export function Item({
  onClick,
  isOpen,
  isSelected,
  onSelect,
  content,
  name,
  value,
}) {
  const selectionHandler = onSelect || (() => null);

  return (
    <div className={styles.item}>
      <div className={styles.controls}>
        <CheckBox
          className={styles.checkBox}
          isChecked={isSelected}
          toggle={selectionHandler}
          name={name}
          value={value}
        />
        <div className={styles.contentWrapper}>
          <span
            className={cx(styles.title, { [styles.titleSelected]: isSelected })}
            onClick={selectionHandler}
          >
            {content.title}
          </span>
          <p
            className={cx(styles.content, {
              [styles.contentCollapsed]: !isOpen,
            })}
            dangerouslySetInnerHTML={{
              __html: content.description,
            }}
          />
        </div>

        <CheveronDownIcon
          className={cx(styles.chevron, {
            [styles.chevronToggled]: isOpen,
          })}
          onClick={onClick}
        />
      </div>
    </div>
  );
}
Item.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  content: PTContentSection,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
};
